import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { getInitials } from 'helpers';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Grid,
  CardHeader,
  CardMedia,
  Chip,
  Avatar, 
  Divider
} from '@material-ui/core';

import {AccessTime, School, Group} from '@material-ui/icons';
import { withRouter } from 'react-router-dom';
import moment from 'moment';


const useStyles = makeStyles(theme => ({
  root: {
    // height: '100%'
  },
  imageContainer: {
    height: 64,
    width: 64,
    margin: '0 auto',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '5px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(3)
  },
  image: {
    width: '100%'
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  statsItem: {
    display: 'flex',
    alignItems: 'center',
  },
  statsIcon: {
    color: theme.palette.icon,
    marginRight: theme.spacing(1)
  },
  title: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    height: 50
  }
}));

const ProductCard = props => {
  const { className, history, product, ...rest } = props;

  const classes = useStyles();

  const checkDetails = (id) => {
    history.push({
      pathname: '/offers/' + id
    });
  };

  let companyLogoURl = "https://cdn-pcs.auicareerspark.com/app-assets/app-assets/def-opportunity.jpg";
  if(product.company_logo && product.company_logo !== "")
    companyLogoURl = product.company_logo;
  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        avatar={
          <Avatar
            aria-label="recipe"
            className={classes.avatar}
            src = {product.creator_profile_picture}
          >
            {getInitials(product.creator_name)}
          </Avatar>
        }
        subheader={'Posted on ' + moment(product.createdAt).format('MMMM Do YYYY, h:mm a')}
        title={product.creator_name + ' from ' + product.company_name}
      />
      <CardMedia
        className={classes.media}
        image={companyLogoURl}
        title="Title"
      />
      <CardContent>
        <Typography
          align="center"
          gutterBottom
          variant="h4"
          className={classes.title}
        >
          {product.title} 
        </Typography>
        <Chip size="small" icon={<School />} color="primary" label={"Targeted major: " + product.targeted_major} />
      </CardContent>
      <Divider />
      <CardActions>
        <Grid
          container
          justify="space-between"
        >
          <Grid
            className={classes.statsItem}
            item
          >
            <AccessTime className={classes.statsIcon} />
            <Typography
              display="inline"
              variant="body2"
            >
              Deadline {moment(product.end_date, 'YYYY-MM-DD HH:mm').fromNow()}
            </Typography>
          </Grid>
          <Grid
            className={classes.statsItem}
            item
          >
            <Button onClick={() => checkDetails(product.hashed_id)} variant="contained" color="primary">

              Check Details
            </Button>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
};

ProductCard.propTypes = {
  className: PropTypes.string,
  product: PropTypes.object.isRequired
};

export default withRouter(ProductCard);
